import { subscribeStyles as styles } from "@insite/content-library/Widgets/Basic/Subscribe";
import { typography as baseThemeTypography } from "@solveindustrial/Utilities/styleguide/index";
import { css } from "styled-components";

styles.mainGridContainer = {
    ...styles.mainGridContainer,
    gap: 10,
};

styles.titleLabel = {
    ...styles.titleLabel,
    forwardAs: "h3",
    weight: 700,
    ...baseThemeTypography.bodyBig,
};

styles.descriptionGridItem = {
    ...styles.descriptionGridItem,
    css: css`
        ${styles.descriptionGridItem?.css}
        text-align: left;
    `,
};

styles.emailTextField = {
    ...styles.emailTextField,
    sizeVariant: "small",
};

styles.emailButton = {
    ...styles.emailButton,
    sizeVariant: "small",
};

styles.disclaimerGridItem = {
    ...styles.disclaimerGridItem,
    css: css`
        ${styles.disclaimerGridItem?.css}
        text-align: left;
    `,
};
